<template>
  <router-view />
</template>

<script>

export default {
  name: 'DocumentWrapper'
}
</script>
